import React from 'react';
import { arc } from 'd3-shape';

const baseArc: string = arc().cornerRadius(0)({
	innerRadius: 0.65,
	outerRadius: 1,
	startAngle: -Math.PI / 2,
	endAngle: Math.PI / 2,
}) as string;

export const Base = () => <path className="base" d={baseArc} />;

export default Base;
